/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUserFoldersResponseItems
 */
export interface GetUserFoldersResponseItems {
    /**
     * 
     * @type {string}
     * @memberof GetUserFoldersResponseItems
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetUserFoldersResponseItems
     */
    icon: number;
    /**
     * 
     * @type {string}
     * @memberof GetUserFoldersResponseItems
     */
    foldername: string;
}

export function GetUserFoldersResponseItemsFromJSON(json: any): GetUserFoldersResponseItems {
    return GetUserFoldersResponseItemsFromJSONTyped(json, false);
}

export function GetUserFoldersResponseItemsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserFoldersResponseItems {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'icon': json['icon'],
        'foldername': json['foldername'],
    };
}

export function GetUserFoldersResponseItemsToJSON(value?: GetUserFoldersResponseItems | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'icon': value.icon,
        'foldername': value.foldername,
    };
}


